import React from 'react';

import MenuNav from './menuNav';
import * as MS from './menu.styles';

interface MenuProps {
  isCollapsed: boolean;
}

const Menu = (props: MenuProps) => {
  const { isCollapsed } = props;

  return (
    <MS.Sidebar width={!isCollapsed ? '13%' : '3%'}>
      <MS.SidebarHeader></MS.SidebarHeader>
      <MenuNav isCollapsed={isCollapsed} />
    </MS.Sidebar>
  );
};

export default Menu;
